import gql from "graphql-tag";

export const getCustomerByAuthToken = gql`
  query getCustomerByAuthToken($authToken: String!) {
    getCustomerByAuthToken(authToken: $authToken) {
      id
      firstName
      lastName
      email
      birthday
      zipcode
      phoneNumber
      pointsBalance
      interestIds
      usageTypeIds
    }
  }
`;

export const getTcpaDetails = gql`
  query getTcpaDetails {
    getTcpaDetails {
      termsAndConditions
      privacyPolicy
    }
  }
`;

export const getCurrentLocation = gql`
  query getCurrentLocation {
    me {
      ... on TenantTabletSelfInfo {
        location {
          name
          locationId
          tenantId
          vendorId
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/api/queries.ts